export const environment = {
	keycloak: 'https://sso.721logistics.com',
	realm: 'isf-shippers-dev',
	client: 'shipper'
};
